// import { useState, useEffect } from "react";
// import { FaEye, FaUpload } from "react-icons/fa";
// import AddIcon from '@mui/icons-material/Add';

// function PhotoUploader({ title, onPhotosChange, existingPhotos = [], userId }) {
//     const [photos, setPhotos] = useState(["", "", "", ""]);
//     const [isOpen, setIsOpen] = useState(false);
//     console.log('photos123', photos)

//     useEffect(() => {
//         if (existingPhotos.length > 0) {
//             setPhotos(existingPhotos);
//         }
//     }, [existingPhotos]);

//     const handleFileChange = (index, event) => {
//         const file = event?.target?.files?.[0];
//         if (!file) return;
//         const newPhotos = [...photos];
//         newPhotos[index] = file;
//         setPhotos(newPhotos);
//     };

//     const handleRemovePhoto = (index) => {
//         const newPhotos = [...photos];
//         newPhotos[index] = "";
//         setPhotos(newPhotos);
//     };

//     const addNewPhotoInput = () => {
//         setPhotos([...photos, ""]);
//     };

//     useEffect(() => {
//         onPhotosChange(photos);
//     }, [photos, onPhotosChange]);

//     return (
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//             <button onClick={() => setIsOpen(true)} style={styles.uploadButton}>
//                 {(userId.startsWith('VC-') || userId.startsWith('VED-')) && (
//                     <span className="flex items-center gap-2">
//                         <FaUpload style={styles.uploadIcon} />
//                         {title}
//                     </span>
//                 )}

//                 {(userId.startsWith('CC-') || userId.startsWith('CUD')) && (
//                     <span className="flex items-center gap-2">
//                         <FaEye style={styles.uploadIcon} />
//                         {title}
//                     </span>
//                 )}

//             </button>

//             {isOpen && (
//                 <div style={styles.overlay}>
//                     <div style={styles.dialog}>
//                         <h2 className="mb-3 ">
//                             <div className="row text-start">
//                                 <div className="col-1">
//                                     {(userId.startsWith('VC-') || userId.startsWith('VED')) && (
//                                     <FaUpload style={styles.uploadIcon} />)}
//                                     {(userId.startsWith('CC-') || userId.startsWith('CUD')) && (
//                                     <FaEye style={styles.uploadIcon} />)}

//                                 </div>
//                                 <div className="col mt-1 font-bold">
//                                     {title.toUpperCase()}
//                                 </div>
//                             </div>
//                         </h2>
//                         <div style={styles.scrollableContent}>
//                             <div className="overflow-auto grid grid-cols-2 lg:grid-cols-5 gap-[0.7rem]">
//                                 {photos.map((photo, index) => (
//                                     <div
//                                         key={index}
//                                         style={{ border: '2px dotted gray' }}
//                                         className="flex flex-col relative p-[0.2rem] rounded-xl items-center justify-center w-[8rem] h-[9rem] m-2"
//                                     >
//                                         {userId.startsWith("VC-") || userId.startsWith("VED-") ? (
//                                             <>
//                                                 {!photo ? (
//                                                     <div className="flex flex-col items-center justify-center mt-[1rem]">
//                                                         <button
//                                                             type="button"
//                                                             style={{ background: 'rgb(140 140 140)' }}
//                                                             className="text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none"
//                                                             onClick={() => document.getElementById(`file-input-${index}`).click()}
//                                                         >
//                                                             <AddIcon />
//                                                         </button>
//                                                         <input
//                                                             type="file"
//                                                             id={`file-input-${index}`}
//                                                             accept="image/*"
//                                                             onChange={(e) => handleFileChange(index, e)}
//                                                             className="form-control text-xs hidden opacity-0"
//                                                         />
//                                                     </div>
//                                                 ) : (
//                                                     <div className="relative w-full h-[8rem] mb-2 mt-[2rem]">
//                                                         <img
//                                                             src={photo instanceof File ? URL.createObjectURL(photo) : photo}
//                                                             alt={`Uploaded ${index + 1}`}
//                                                             className="w-full h-full rounded-xl object-cover"
//                                                         />
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => handleRemovePhoto(index)}
//                                                             className="absolute top-0 right-0 bg-red-200 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
//                                                             title="Remove Image"
//                                                         >
//                                                             ❌
//                                                         </button>

//                                                     </div>
//                                                 )}
//                                             </>
//                                         ) : (
//                                             <div className="w-full h-[5rem] flex">
//                                                 <img
//                                                     src={photo}
//                                                     alt={`Uploaded ${index + 1}`}
//                                                     className="w-full h-full rounded-xl object-cover"
//                                                 />
//                                             </div>
//                                         )}
//                                         <label className=" mt-3 text-center bottom-2 text-[12px] font-medium text-gray-700">
//                                             Image {index + 1}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>

//                         </div>
//                         {(userId.startsWith("VC") || userId.startsWith("VED-")) && (
//                             <div className="flex justify-end">
//                                 <button
//                                     className="px-4 py-2 bg-gray-700 text-white rounded-xl"
//                                     onClick={addNewPhotoInput}
//                                 >
//                                     Add New
//                                 </button>
//                             </div>
//                         )}

//                         <button className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all mt-3 w-full bg-[#21A6E9] hover:bg-[#1e94d6]" onClick={() => setIsOpen(false)} >
//                             Done
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// const styles = {
//     uploadButton: {
//         display: "flex",
//         alignItems: "center",
//         gap: "8px",
//         // backgroundColor: "#007bff",
//         // color: "white",
//         border: "none",
//         padding: "10px 15px",
//         cursor: "pointer",
//         borderRadius: "5px",
//         fontSize: "16px",
//     },
//     uploadIcon: {
//         fontSize: "18px",
//     },
//     overlay: {
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         backgroundColor: "rgba(0, 0, 0, 0.5)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 9999,
//     },
//     dialog: {
//         backgroundColor: "white",
//         padding: "20px",
//         borderRadius: "10px",
//         textAlign: "center",
//         width: "350px",
//         maxHeight: "80vh",
//         overflow: "hidden",
//         boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//         display: "flex",
//         flexDirection: "column",
//     },
//     scrollableContent: {
//         maxHeight: "50vh",
//         overflowY: "auto",
//         paddingRight: "5px",
//         borderBottom: "1px solid #ccc",
//         marginBottom: "10px",
//         display: 'flex'
//     },
//     imagePreview: {
//         width: "100px",
//         height: "50px",
//         marginTop: "5px",
//         objectFit: "cover",
//         borderRadius: "5px",
//     },
//     closeButton: {
//         marginTop: "10px",
//         backgroundColor: "#ff4d4d",
//         color: "white",
//         border: "none",
//         padding: "8px 12px",
//         cursor: "pointer",
//         borderRadius: "5px",
//     },
// };

// export default PhotoUploader;

import { useState, useEffect } from "react";
import { FaEye, FaUpload } from "react-icons/fa";
import AddIcon from "@mui/icons-material/Add";

import frontRight from "../../../Assets/crane/front-right.jpg";
import frontLeft from "../../../Assets/crane/front-left.jpg";
import rearRight from "../../../Assets/crane/rear-right.jpg";
import rearLeft from "../../../Assets/crane/rear-left.jpg";

// import frontRight from "../../../Assets/crane/front-right-n.jpg";


function PhotoUploader({
    title,
    onPhotosChange,
    existingPhotos = [],
    userId,
    placeholderImages = []
}) {
    const [photos, setPhotos] = useState(["", "", "", "", "", ""]);
    const [previews, setPreviews] = useState(["", "", "", "", "", ""]);
    const [isOpen, setIsOpen] = useState(false);

    // Determine labels based on the title
    const labels =
        title === "Tyres Images"
            ? ["Slot 1", "Slot 2", "Slot 3", "Slot 4", "Stepney", ""]
            : [
                "Front Right",
                "Front Left",
                "Rear Right",
                "Rear Left",
                "Odometer",
                "Selfie with Truck"
            ];


    const fallbackPlaceholders = [frontRight, frontLeft, rearRight, rearLeft];
    const activePlaceholders =
        placeholderImages.length > 0 ? placeholderImages : fallbackPlaceholders;

    useEffect(() => {
        if (existingPhotos.length > 0) {
            setPhotos(existingPhotos);
            const generatedPreviews = existingPhotos.map(photo =>
                photo instanceof File ? URL.createObjectURL(photo) : photo
            );
            setPreviews(generatedPreviews);
        }
    }, [existingPhotos]);

    useEffect(() => {
        const newPreviews = photos.map((photo, index) => {
            if (!photo) return "";
            return photo instanceof File ? URL.createObjectURL(photo) : photo;
        });
        setPreviews(newPreviews);
        onPhotosChange(photos);
    }, [photos]);

    const handleFileChange = (index, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const newPhotos = [...photos];
        newPhotos[index] = file;
        setPhotos(newPhotos);
    };

    const handleRemovePhoto = index => {
        const newPhotos = [...photos];
        newPhotos[index] = "";
        setPhotos(newPhotos);
    };

    return (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button onClick={() => setIsOpen(true)} style={styles.uploadButton}>
                {(userId.startsWith("VC-") || userId.startsWith("VED-")) && (
                    <span className="flex items-center gap-2">
                        <FaUpload style={styles.uploadIcon} />
                        {title}
                    </span>
                )}
                {(userId.startsWith("CC-") || userId.startsWith("CUD")) && (
                    <span className="flex items-center gap-2">
                        <FaEye style={styles.uploadIcon} />
                        {title}
                    </span>
                )}
            </button>

            {isOpen && (
                <div style={styles.overlay}>
                    <div style={styles.dialog}>
                        <h2 className="mb-3">
                            <div className="row text-start">
                                <div className="col-1">
                                    {(userId.startsWith("VC-") || userId.startsWith("VED")) && (
                                        <FaUpload style={styles.uploadIcon} />
                                    )}
                                    {(userId.startsWith("CC-") || userId.startsWith("CUD")) && (
                                        <FaEye style={styles.uploadIcon} />
                                    )}
                                </div>
                                <div className="col mt-1 font-bold">{title.toUpperCase()}</div>
                            </div>
                        </h2>

                        <div style={styles.scrollableContent}>
                            <div className="overflow-auto grid grid-cols-2 lg:grid-cols-5 gap-[0.7rem]">
                                {photos.map((photo, index) => {
                                    if (title === "Tyres Images" && index === 5) return null; // Skip 6th slot

                                    const isEmpty = !photo;
                                    const imageSrc = isEmpty
                                        ? (title === "Tyres Images" ? null : activePlaceholders[index % activePlaceholders.length])
                                        : (photo instanceof File ? URL.createObjectURL(photo) : photo);

                                    return (
                                        <div
                                            key={index}
                                            className="relative flex flex-col items-center justify-end w-[8rem] h-[9rem] border-2 border-dotted border-gray-400 rounded-xl overflow-hidden cursor-pointer"
                                            onClick={() => document.getElementById(`file-input-${index}`)?.click()}
                                        >
                                            {imageSrc && (
                                                <img
                                                    src={imageSrc}
                                                    alt={`Image ${index + 1}`}
                                                    className={`absolute top-0 left-0 w-full h-full object-cover ${isEmpty ? "opacity-60" : "opacity-100"}`}
                                                />
                                            )}

                                            {!isEmpty && (
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemovePhoto(index);
                                                    }}
                                                    className="absolute top-1 right-1 bg-red-600 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs hover:bg-red-700 z-20"
                                                    title="Remove Image"
                                                >
                                                    ✕
                                                </button>
                                            )}

                                            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#000000a0] text-white rounded-full p-2">
                                                <AddIcon fontSize="small" />
                                            </div>

                                            <div className="w-full text-center z-10 bg-black bg-opacity-60 text-white text-xs py-1 font-semibold">
                                                {title === "Tyres Images"
                                                    ? index === 4
                                                        ? "Stepney"
                                                        : `Tyre Image ${index + 1}`
                                                    : labels[index] || ""}
                                            </div>


                                            <input
                                                type="file"
                                                id={`file-input-${index}`}
                                                accept="image/*"
                                                onChange={(e) => handleFileChange(index, e)}
                                                style={{ display: 'none' }}
                                            />
                                        </div>
                                    );
                                })}


                            </div>
                        </div>

                        <button
                            className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all mt-3 w-full bg-[#21A6E9] hover:bg-[#1e94d6]"
                            onClick={() => setIsOpen(false)}
                        >
                            Done
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

const styles = {
    uploadButton: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        border: "none",
        padding: "10px 15px",
        cursor: "pointer",
        borderRadius: "5px",
        fontSize: "16px"
    },
    uploadIcon: {
        fontSize: "18px"
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
    },
    dialog: {
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "10px",
        textAlign: "center",
        width: "350px",
        maxHeight: "80vh",
        overflow: "hidden",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        display: "flex",
        flexDirection: "column"
    },
    scrollableContent: {
        maxHeight: "50vh",
        overflowY: "auto",
        padding: "0 1rem",
        borderBottom: "1px solid #ccc",
        marginBottom: "10px"
    }
};

export default PhotoUploader;
